// @systeme: interface
// Les interrupteurs de l'admin : ce qui est éteint n'apparaît pas. Le serveur refuse
// aussi de son côté ; ici on cache seulement, pour ne pas montrer une porte fermée.
import type { Fonctionnalite, ReponseSession } from '@foyer/shared';

export function fonctionActive(session: ReponseSession, cle: Fonctionnalite): boolean {
  return session.fonctionnalites[cle] !== false;
}
